import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const setTickerState = (ticker, paused) => {
  ticker.classList.toggle('is-paused', paused);
  const button = ticker.querySelector('[data-lp-promo-toggle]');
  if (!button) return;
  button.setAttribute('aria-pressed', String(paused));
  button.setAttribute('aria-label', paused ? 'Reanudar anuncio' : 'Pausar anuncio');
};

document.querySelectorAll('[data-lp-promo-ticker]').forEach((ticker) => {
  const button = ticker.querySelector('[data-lp-promo-toggle]');
  button?.addEventListener('click', () => setTickerState(ticker, !ticker.classList.contains('is-paused')));
  ticker.addEventListener('focusin', () => setTickerState(ticker, true));
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) setTickerState(ticker, true);
  });
  observer.observe(ticker);
});

const addPromoRecommendation = async (button) => {
  const variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((component) => component.dataset.sectionId)
    .filter(Boolean);
  const deferredEventPromise = CartLinesUpdateEvent.createPromise();
  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Agregando…';
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferredEventPromise.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { Modelo: button.dataset.model || '' } }],
        sections: sectionIds.join(','),
      }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'No se pudo agregar');

    const cartResponse = await fetch(`${Theme.routes.cart_url}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!cartResponse.ok) throw new Error('No se pudo actualizar el carrito');
    const cart = await cartResponse.json();

    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'lp-promo-cart',
        sourceId: 'lp-promo-cart',
        sections: result.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferredEventPromise.reject(error);
    button.dispatchEvent(
      new CartErrorEvent({
        error: error?.message || 'No se pudo agregar la gorra',
        code: 'INVALID',
      })
    );
    button.disabled = false;
    button.textContent = originalText;
  }
};

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest('[data-lp-promo-add]');
  if (button instanceof HTMLButtonElement) addPromoRecommendation(button);
});
